import { Component, effect } from "@angular/core";
import { TileComponent } from "../../../../shared/components/tile/tile.component";
import { MenuService } from "../../../../theme/services/menu.service";
import { AuthenticationService } from "../../../../shared/services/authentication/authentication.service";
import { Menu } from "../../../../theme/components/menu/menu.model";
import { DASHBOARD_ITEMS } from "../../../../../../public/assets/config/constants";
import { DashboardListItem } from "../../../../models/dashboard.model";
import { MatDividerModule } from "@angular/material/divider";
import { DashboardService } from "../../services/dashboard.service";
import { AccountInfo } from "@azure/msal-browser";
import { ConfigService } from "../../../../shared/services/config/config.service";

@Component({
  selector: "app-dashboard",
  imports: [TileComponent, MatDividerModule],
  templateUrl: "./dashboard.component.html",
  styleUrl: "./dashboard.component.scss",
})
export class DashboardComponent {
  menuItems: Menu[] = [];
  dashboardItems: DashboardListItem[] = [];
  userRoles: string[] = [];
  userProfile: AccountInfo | null = null;

  constructor(
    public menuService: MenuService,
    public authenticationService: AuthenticationService,
    public dashboardService: DashboardService,
    private configService: ConfigService

  ) {
    effect(() => {
      this.userRoles = this.authenticationService.getUserRoles();
      this.menuItems = this.menuService.getVerticalMenuItems();
      this.updateDashboardItems();
    });
    effect(() => {
      this.userProfile = this.authenticationService.userSignal();
    });
    this.userProfile = this.authenticationService.userSignal();
    this.dashboardItems = DASHBOARD_ITEMS;
    this.menuItems = this.menuService.getVerticalMenuItems();
  }

  ngOnInit() {
    const profile = localStorage.getItem("profile");
    const profileData = profile ? JSON.parse(profile) : null;
    const needsUpdate = !profileData || 
                       profileData.userName !== this.userProfile?.username || 
                       !profileData.isUpdated ||
                       !profileData.id;

    if (needsUpdate) {
      this.getUserProfile();
    } else {
      this.updateDashboardItems();
    }
    
  }

  updateDashboardItems(): void {
    // Get favorites from localStorage
    const userProfile = JSON.parse(localStorage.getItem("profile") as string);
    const favorites = userProfile?.favorite
      ? userProfile.favorite.split(",")
      : [];

    // Update dashboard items based on matching IDs and favorites
    this.dashboardItems = this.dashboardItems.map((dashboardItem) => {
      // Find matching menu item
      const matchingMenuItem = this.menuItems.find(
        (menuItem) => menuItem.id === dashboardItem.id
      );
      // Check if item is in favorites
      const isFavorite = favorites.includes(dashboardItem.cardKey);

      return {
        ...dashboardItem,
        disabled: !matchingMenuItem,
        favorite: isFavorite,
      };
    });
    console.log("dashboardItems", this.dashboardItems);
  }

  hasFavorites(): boolean {
    return this.dashboardItems.some((item) => item.favorite && !item.disabled);
  }

  areAllItemsDisabled(): boolean {
    return this.dashboardItems.length > 0 && this.dashboardItems.every((item) => item.disabled);
  }

  getUserProfile(): void {
    this.dashboardService
      .getUserProfile(this.userProfile?.username as string)
      .subscribe((profile) => {
        if (Array.isArray(profile)) {
          return;
        }
        const profileWithUpdateFlag = { ...profile, isUpdated: true };
        localStorage.setItem("profile", JSON.stringify(profileWithUpdateFlag));
        this.setUserRolesAndFavorites();
        this.updateDashboardItems();
      });
  }

  setUserRolesAndFavorites(): void {
    const isRBACTestEnabled =
            this.configService.getConfigProperty("RBAC_TEST_ENABLED");
    if (isRBACTestEnabled) {
      const profile = localStorage.getItem("profile");
      if (profile) {
        const profileData = JSON.parse(profile);
        if (profileData.id && profileData.userName === this.userProfile?.username) {
          this.userRoles = profileData.roles.split(",").map((role: string) => role.trim());
          this.authenticationService.setUserRoles(this.userRoles);
        }
      }
    }

  }
}
